import { ColoredTextFindReplaceItem, ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { AnonymizerRule } from 'src/app/domainObjects/transformers/anonymizerTransform';


export class AnonymizerRuleViewModel extends TransformRuleViewModel {
    anonType: AnonType
    fields: ColoredTextItem[];
    preservedTerms: ColoredTextItem[];
    mapTerms: ColoredTextFindReplaceItem[];
    ruleOption:RuleOptions;
    wordSepMode:WordSepMode;
    mapOnly: boolean;
    matchCase: boolean;
    findTerms: ColoredTextItem[];
    andOr:AndOr;

    preAnonType: AnonType;

    rowHits?: number;
    sampleRowHits?: number;

    constructor(rule: AnonymizerRule) {
      super(rule.ruleId, rule.index, rule.run, rule.ruleName);
      this.anonType = rule.anonType;
      let colorIndex = 0;
      this.fields = rule.fields?.map(r => new ColoredTextItem(r, NamedColorList[colorIndex++])) ?? [];
      colorIndex = 0;
      this.preservedTerms = rule.preservedTerms?.map(r => {
          const color = NamedColorList[colorIndex % NamedColorList.length];
          colorIndex++;
          return new ColoredTextItem(r, color);
      }) ?? [];
      colorIndex = 0;
      this.mapTerms = rule.mapTerms 
              ? Object.entries(rule.mapTerms).map(([find, replace], index) => {
                  // Reset or cycle through the NamedColorList array with colorIndex modulo NamedColorList length
                  const color = NamedColorList[index % NamedColorList.length];
                  return new ColoredTextFindReplaceItem(find, replace, color);
                })
              : [];
      this.ruleOption = rule.ruleOption;
      this.wordSepMode = rule.wordSepMode;
      this.mapOnly = rule.mapOnly;
      this.matchCase = rule.matchCase;
      this.findTerms = rule.findTerms?.map(r => new ColoredTextItem(r, NamedColorList[colorIndex++])) ?? [];
      this.andOr = rule.andOr;

      this.preAnonType = rule.anonType;
    }

    toRule(): AnonymizerRule {
      const rule = new AnonymizerRule();

      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.anonType = this.anonType;
      rule.fields = this.fields?.map(i => i.text);
      rule.preservedTerms = this.preservedTerms?.map(i => i.text);
      if(this.mapTerms.length===0){
        rule.mapTerms=undefined;
      }else{
        rule.mapTerms={};
        this.mapTerms.forEach(item => {
          rule.mapTerms[item.find] = item.replace;
        });
      }
      if(this.anonType===AnonType.Name || this.anonType===AnonType.JoinID || this.anonType===AnonType.Location || this.anonType===AnonType.Details || this.anonType===AnonType.Category || this.anonType===AnonType.URL || this.anonType===AnonType.Date || this.anonType===AnonType.Time){
        rule.ruleOption = this.ruleOption;
      }else{
        rule.ruleOption = undefined;
      }
      if(this.anonType===AnonType.Name || this.anonType===AnonType.Details || this.anonType===AnonType.Category || this.anonType===AnonType.URL || this.anonType===AnonType.Time){
        rule.wordSepMode = this.wordSepMode;
      }else{
        rule.wordSepMode = undefined;
      }
      rule.mapOnly = this.mapOnly;
      rule.matchCase = this.matchCase;
      rule.findTerms = this.findTerms?.map(i => i.text);
      rule.andOr = this.andOr;
      rule.run = this.run;
      return rule;
    }
}
export enum AnonType{
    Name = 0,
    Category = 1,
    CategorySerial = 2,
    Email = 3,
    Phone = 4,
    Location = 5,
    ID = 6,
    JoinID = 7,
    Integer = 8,
    Decimal = 9,
    Date = 10,
    Time = 11,
    Details = 12,
    URL = 13
}
export class AnonTypeUtil {
  static toString(anumType: AnonType): string {
      switch (anumType) {
        case AnonType.Name: return 'Name';
        case AnonType.Category: return 'Category';
        case AnonType.CategorySerial: return 'Category Serial';
        case AnonType.Email: return 'Email';
        case AnonType.Phone: return 'Phone';
        case AnonType.Location: return 'Location';
        case AnonType.ID: return 'ID';
        case AnonType.JoinID: return 'Join ID';
        case AnonType.Integer: return 'Integer';
        case AnonType.Decimal: return 'Decimal';
        case AnonType.Date: return 'Date';
        case AnonType.Time: return 'Time';
        case AnonType.Details: return 'Details';
        case AnonType.URL: return 'URL';
      }
  }
}

export enum AndOr{
    or = 0,
    and = 1,
}
export class AndOrUtil {
  static toString(andor: AndOr): string {
      switch (andor) {
        case AndOr.or: return 'OR';
        case AndOr.and: return 'AND';
      }
  }
}

export enum RuleOptions{
  Keep = 0,
  DontKeep = 1,
  US = 2,
  Canada = 3,
  Mexico = 4,
  Brazil = 5,
  Netherlands = 6,
  France = 7,
  Germany = 8,
  UK = 9,
  Benelux = 10,
  Scandinavia = 11,
  WesternEurope = 12,
  Generic = 13,
  Healthcare = 14,
  Insurance = 15,
  Finance = 16,
  HCtoInsur = 17,
  HCtoFinance = 18,
  InsurtoFinance = 19,
  InsurtoHC = 20,
  FinancetoHC = 21,
  FinancetoInsur = 22,
  Decade = 23,
  Halfdecade = 24,
  Year = 25,
  Month = 26,
  TimeShift2 = 27,
  TimeShift10 = 28,
  TimeShift25 = 29,
  TimeShift50 = 30
}
export class RuleOptionsUtil {
  static toString(ruleOption: RuleOptions): string {
      switch (ruleOption) {
        case RuleOptions.Keep: return 'Keep Format';
        case RuleOptions.DontKeep: return 'New Format';
        case RuleOptions.US: return 'US';
        case RuleOptions.Canada: return 'Canada';
        case RuleOptions.Mexico: return 'Mexico';
        case RuleOptions.Brazil: return 'Brazil';
        case RuleOptions.Netherlands: return 'Netherlands';
        case RuleOptions.France: return 'France';
        case RuleOptions.Germany: return 'Germany';
        case RuleOptions.UK: return 'UK';
        case RuleOptions.Benelux: return 'Benelux';
        case RuleOptions.Scandinavia: return 'Scandinavia';
        case RuleOptions.WesternEurope: return 'Western Europe';
        case RuleOptions.Generic: return 'Generic';
        case RuleOptions.Healthcare: return 'Healthcare';
        case RuleOptions.Insurance: return 'Insurance';
        case RuleOptions.Finance: return 'Finance';
        case RuleOptions.HCtoInsur: return 'HCtoInsur';
        case RuleOptions.HCtoFinance: return 'HCtoFinance';
        case RuleOptions.InsurtoFinance: return 'InsurtoFinance';
        case RuleOptions.InsurtoHC: return 'InsurtoHC';
        case RuleOptions.FinancetoHC: return 'FinancetoHC';
        case RuleOptions.FinancetoInsur: return 'FinancetoInsur';
        case RuleOptions.Decade: return 'Decade';
        case RuleOptions.Halfdecade: return 'Halfdecade';
        case RuleOptions.Year: return 'Year';
        case RuleOptions.Month: return 'Month';
        case RuleOptions.TimeShift2: return 'Time shift 2%';
        case RuleOptions.TimeShift10: return 'Time shift 10%';
        case RuleOptions.TimeShift25: return 'Time shift 25%';
        case RuleOptions.TimeShift50: return 'Time shift 50%';
      }
  }
}
export enum WordSepMode{
  all = 0,
  space = 1,
  underscore = 2,
  slash = 3,
  capital = 4,
  dot = 5,
  slashDot = 6,
  dash = 7,
  LastFirst = 8,
  FirstLast = 9,
  Last = 10,
  First = 11,
  HalfHour = 12,
  OneHour = 13,
  TwoHours = 14,
  FourHours = 15,
  EightHours = 16
}
export class WordSepModeUtil {
  static toString(wordSepMode: WordSepMode): string {
      switch (wordSepMode) {
        case WordSepMode.all: return 'All';
        case WordSepMode.space: return 'Space';
        case WordSepMode.underscore: return 'Underscore';
        case WordSepMode.slash: return 'Slash (/)';
        case WordSepMode.capital: return 'Capital';
        case WordSepMode.dot: return 'Dot (.)';
        case WordSepMode.slashDot: return 'Slash & Dot';
        case WordSepMode.dash: return 'Dash (-)';
        case WordSepMode.LastFirst: return 'Last, First';
        case WordSepMode.FirstLast: return 'First Last';
        case WordSepMode.Last: return 'Last';
        case WordSepMode.First: return 'First';
        case WordSepMode.HalfHour: return 'Half hour';
        case WordSepMode.OneHour: return 'One hour';
        case WordSepMode.TwoHours: return 'Two hours';
        case WordSepMode.FourHours: return 'Four hours';
        case WordSepMode.EightHours: return 'Eight hours';
      }
  }
}

